import styled from 'styled-components';
import theme, { appTheme } from '../../theme';

export const InfoActivityContainer = styled.div`
  width: 100%;
  background-color: ${appTheme.cardB2};
`;

export const Separator = styled.div`
  background-color: ${appTheme.background};
  width: 100%;
  height: 2px;
`;

export const InfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  padding: 10px;
`;

export const InfoActivityText = styled.p`
  color: ${appTheme.title};
`;

export const ActivityTitleContainer = styled.div<{ isValidated: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 23px;
  padding-bottom: 18px;
  background: ${theme.colors.cardB2};
`;

export const ActivityTitle = styled.h3`
  color: white;
  text-transform: uppercase;
  font-weight: bold;
`;

export const ActivityInfoContainer = styled.div<{ isValidated: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 23px;
  background: ${theme.colors.cardB2};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const InfoText = styled.p`
  font-size: 16px; 
  padding-top: 13px;
  color: white;
  font-weight: 600;
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 410px;
  background-color: ${appTheme.cardB2};
`;

export const MedalRequestContainer = styled.div`
  margin-top: 13px;
  margin-bottom: 13px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;

export const MedalRequestInfo = styled.p`
  font-size: 16px; 
  padding-top: 13px;
  color: white;
  font-weight: 600;
`;

export const RegisterButton = styled.button<{color?: string}>`
  width: 50%;
  background-color: ${({ color }) => (color || 'transparent')};
  border-radius: 5px;
  align-items: center;
  border: '1px';
  border-style: solid;
  border-color: ${({ color }) => (color || theme.colors.title)};
  align-self :center;
  padding: 10px;
  cursor: pointer;
  &:hover {
      opacity: 0.7;
    }
`;

export const RegisterButtonText = styled.span<{color?: string}>`
  color: ${({ color }) => (color || theme.colors.title)};
  font-weight: bold;
  font-size: 15px;
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: ${appTheme.cardB2};
`;

export const CarouselContent = styled.div`
  width: 100%;
  overflow: hidden;
  flex: 1;
`;

export const CarouselArrow = styled.button`
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
  flex-shrink: 0;

  &:hover {
    background-color: rgba(255, 255, 255, 1);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  svg {
    width: 20px;
    height: 20px;
    color: ${theme.colors.primary};
  }

  @media (max-width: 667px) {
    width: 35px;
    height: 35px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const CarouselArrowLeft = styled(CarouselArrow)`
`;

export const CarouselArrowRight = styled(CarouselArrow)`
`;

export const CarouselIndicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 15px 0;
  width: 100%;
  background-color: ${appTheme.cardB2};
`;

export const IndicatorDot = styled.div<{ active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ active }) => (active ? theme.colors.primary : 'rgba(255, 255, 255, 0.3)')};
  transition: background-color 0.3s;
`;
